<template lang='pug'>
  #app
    bionic-metrics-header
    v-main.full
      router-view
    bionic-metrics-footer
</template>

<script>
import BionicMetricsLoadingBar from '../../components/LoadingBar';
import BionicMetricsHeader from '../../components/Header';
import BionicMetricsFooter from '../../components/Footer';

export default {
  components: {
    BionicMetricsFooter,
    BionicMetricsHeader,
    BionicMetricsLoadingBar
  },
  name: 'Home',
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #app {
    width: 100%;
    height: 100%;
  }

  .full {
    width: 100%;
    height: 100%;
  }
</style>
